import React, { useCallback, useEffect, useState } from "react";
import dayjs from "dayjs";
import styled from "styled-components";
import LineBtn from "../../../Button/LineBtn";
import LineBox from "../../../DefaultStyles/LineBox";
import Loader from "../../../DefaultStyles/Loader";
import { More } from "./ChatSearch/RecentChat";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { chatTabState } from "./ChatTab";
import { useLocation, useNavigate } from "react-router-dom";
import { recentChatBtnClick } from "./ChatSearch/ChatSearchResult";
import Flex from "../../../DefaultStyles/Flex";
import { findUrl } from "../../../../ApiWeb/ApiWebTS";
import { io } from "socket.io-client";
import axios from "axios";
import { decryptChat, encryptChat } from "../../../../ApiTS/web/ApiChatTS";
import { useInView } from "react-intersection-observer";
import { toast } from "react-toastify";
import useIsMobile from "../../../../hooks/useIsMobile";
import { isBeta } from "../../../../AdminConfig";
import moment from "moment";

interface IAllChat {
  id: number;
  writer: number;
  message: string;
  url?: string;
  image?: string;
  isRead: number;
  date: string;
  partyid: number;
  roomid: number;
  targetUid: number;
  ownerid?: number;
  memberid?: number;
}

// export const isLocalServer = process.env.NODE_ENV === "development" && isBeta;
export const isLocalServer = false;

export const chatSocketUrl = isBeta
  ? isLocalServer
    ? `http://peachgrove.synology.me:7356`
    : `https://beta.linkid.pw/socket`
  : "https://linkid.pw/socket";

export const chatServerUrl = isBeta
  ? isLocalServer
    ? `http://peachgrove.synology.me:7356`
    : `https://beta.linkid.pw/chat`
  : "https://linkid.pw/chat";

let mountCount = 1;

interface PartyChatProps {
  partyId?: string;
}

export default function RecentChatParty({ partyId }: PartyChatProps) {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const location = useLocation();

  const chatTab = useRecoilValue(chatTabState);
  const [didMount, setDidMount] = useState(false);
  const [page, setPage] = useState(0);
  const [allChatList, setAllChatList] = useState<IAllChat[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const setTab = useSetRecoilState(chatTabState);
  const setRecentBtnClick = useSetRecoilState(recentChatBtnClick);
  const [lastRef, lastInView] = useInView({
    threshold: 0.8,
    fallbackInView: true,
  });

  const tableHead = ["보낸 사람", "받는 사람", "내용", "발송 일시", "읽음"];

  const getAllChat = useCallback(async () => {
    console.log("socket connect");

    console.log("chat room!!");
    console.log(allChatList?.length);
    setIsLoading(true);

    const queryStr = `${chatServerUrl}/message/all?size=${
      isMobile ? 5 : 5
    }&mindex=${allChatList?.length ?? 0}&partyid=${Number(partyId)}`;

    const encMsg = "나는채팅" + moment().format("DDHHYYYYMM") + "_0";

    const encOwnerSuperKey = encryptChat(encMsg);
    const encOwnerSuperKeyValueSid = "tbvjzl" + `${0}_` + encOwnerSuperKey;

    try {
      const response = await axios.get(queryStr, {
        data: {
          sid: encOwnerSuperKeyValueSid,
        },
      });

      if (response?.status === 200) {
        setIsLoading(false);
        setHasMore(response?.data?.totalPage > page ? true : false);

        setAllChatList((prev) => {
          return [...prev, ...response?.data?.items];
        });
      } else {
        setIsLoading(false);
      }

      return response.data;
    } catch (error: any) {
      setIsLoading(false);

      console.log(error);

      if (error) {
        toast.error(error?.data ?? "전체 대화 조회에 실패했습니다.");
      }
    }
  }, [partyId]);

  useEffect(() => {
    console.log(chatTab);

    if (chatTab === 0) {
      const socket = io(`${chatSocketUrl}`, {
        reconnection: false,
        transports: ["websocket"],
      });

      socket.on("connect", () => {
        console.log("😀 socket is connected");
        socket.emit("InAdmin");
      });

      socket.on("connect_error", (error) => {
        console.log("🥲 socket has connect_error: " + error);
        // alert("소켓 연결에 문제가 있습니다. 새로고침 해주세요.");
        // window.location.href = window.location.href;
        // socket.connect(); // reconnect
      });

      socket.on("disconnect", (reason) => {
        console.log(`🥲 socket is disconnected: ${reason}`);
        // socket.connect();
        console.log(socket);
      });

      socket.on("reconnect", () => {
        console.log("😀 socket is reconnected!");
      });

      socket.on(
        "receiveMessage",
        (data: {
          date: string;
          id: number;
          isRead: number;
          message: string;
          partyid: number;
          roomId: number;
          targetUid: number;
          writer: number;
          ownerid: number;
          memberid: number;
        }) => {
          console.log("✨ I got message: ", data);

          setAllChatList((prev) => {
            const hasSameId =
              prev.filter((a) => a.id === data.id)?.length > 0 ? true : false;

            if (!hasSameId) {
              return [
                {
                  id: data.id,
                  roomid: data.roomId,
                  partyid: data.partyid,
                  writer: data.writer,
                  targetUid: data.targetUid,
                  isRead: data.isRead,
                  message: data.message,
                  date: data.date,
                  ownerid: data.ownerid,
                  memberid: data.memberid,
                },
                ...prev,
              ];
            } else {
              return [...prev];
            }
          });
        }
      );

      return () => {
        socket.disconnect();
      };
    }
  }, [chatTab]);

  useEffect(() => {
    setAllChatList([]);
    getAllChat();
  }, [partyId]);

  useEffect(() => {
    console.log("mount: ", mountCount);
    mountCount++;
    setDidMount(true);

    return () => {
      console.log("unmount");
    };
  }, []);

  useEffect(() => {
    console.log("didMount: ", didMount);
    if (didMount) {
      console.log("api 호출");
      setPage((prev) => prev + 1);
    }
  }, [didMount]);

  useEffect(() => {
    // 더 보여줄 page가 있고, 제일 상단 메세지가 보이면 page + 1
    if (lastInView && hasMore) {
      setPage((prev) => prev + 1);
    }
  }, [lastInView, hasMore]);

  useEffect(() => {
    console.log(allChatList);
  }, [allChatList]);

  // useEffect(() => {
  //   if (chatTab === 0) {
  //     console.log(socket);

  //     if (socket.connected) {
  //       socket.disconnect();
  //     }

  //     socket.connect();
  //   }

  //   return () => {
  //     socket.disconnect();
  //   };
  // }, [chatTab]);

  return (
    <LineBox id="line-box">
      <ChatContainer>
        <ChatHeader>
          {tableHead?.map((t) => (
            <ChatHeaderItem key={t}>{t}</ChatHeaderItem>
          ))}
        </ChatHeader>

        <ChatContent isMobile={isMobile} allChatList={allChatList}>
          {allChatList?.map((c, index) => {
            const pureMsg = decryptChat(c?.message ?? "") ?? "";

            const isOldestChat = allChatList.length === index + 1; // 가장 오래된 메세지
            const isLastChat = allChatList[0]?.id === c?.id;

            return (
              <ChatRow
                key={c.id}
                ref={isOldestChat ? lastRef : undefined}
                style={{
                  backgroundColor:
                    c.writer === c.ownerid ? "#fffae8" : "#ffffff",
                }}
              >
                <ChatRowItem
                  clickable
                  onClick={() => navigate(`/users/info/${c.writer}`)}
                >
                  {c.writer === c.ownerid ? "파티장" : c.writer}
                </ChatRowItem>
                <ChatRowItem
                  clickable
                  onClick={() => navigate(`/users/info/${c.targetUid}`)}
                >
                  {c.targetUid === c.ownerid ? "파티장" : c.targetUid}
                </ChatRowItem>
                <ChatRowItem>
                  <Flex>
                    <ChatMessage
                      dangerouslySetInnerHTML={{
                        __html: findUrl(pureMsg),
                      }}
                      onClick={() => {
                        const urlRegex =
                          /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;

                        const hasUrl = urlRegex?.test(pureMsg);

                        if (hasUrl) {
                          window.open(pureMsg);
                        }
                      }}
                    />

                    <>
                      {isLastChat && (
                        <LatestMessageBadge isSystem={true}>
                          가장 최근 메세지
                        </LatestMessageBadge>
                      )}
                    </>
                  </Flex>
                </ChatRowItem>
                <ChatRowItem>
                  {dayjs(c?.date)?.format("YYYY-MM-DD HH:mm:ss")}
                </ChatRowItem>
                <ChatRowItem>
                  {
                    <Icon
                      src={require(`../../../../assets/${
                        c.isRead === 1 ? "check_blue_24" : "check_black_24"
                      }@2x.png`)}
                    />
                  }
                </ChatRowItem>
              </ChatRow>
            );
          })}
        </ChatContent>

        {isLoading && <Loader />}
      </ChatContainer>
    </LineBox>
  );
}

export const ChatMessage = styled.div`
  a {
    all: unset;
    cursor: pointer;
    text-decoration: underline;
    overflow-wrap: anywhere;
  }
`;

export const ChatContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const ChatHeader = styled.div`
  position: sticky;
  top: 0;
  width: 100%;
  min-width: 750px;
  border-bottom: 2px solid #d4d9e1;
  background-color: white;
  display: flex;
  align-items: center;
  padding-right: 20px;
`;

export const ChatHeaderItem = styled.div`
  width: 100%;

  padding: 11px 10px;
  word-break: keep-all;
  font-size: 15px;
  font-weight: bold;
  line-height: 22.5px;
  text-align: left;
  color: #858c97;
  vertical-align: bottom;

  &:nth-child(1) {
    flex: 1;
  }

  &:nth-child(2) {
    flex: 1;
  }

  &:nth-child(3) {
    flex: 4;
  }

  &:nth-child(4) {
    flex: 2;
  }

  &:nth-child(5) {
    flex: 1;
  }
`;

export const ChatContent = styled.div<{
  isMobile: boolean;
  allChatList: IAllChat[];
}>`
  width: 100%;
  display: flex;
  flex-direction: column-reverse;
  height: ${({ isMobile, allChatList }) =>
    allChatList?.length > 0 ? (isMobile ? "40vh" : "300px") : "10px"};
  overflow-y: scroll;
`;

export const ChatRow = styled.div<{ grade?: number; isSystem?: boolean }>`
  width: 100%;
  min-width: 750px;

  display: flex;
  align-items: center;
  border-bottom: 1px solid #d4d9e1;
  /* background-color: ${({ grade }) =>
    grade === 0 ? "#fffae8" : grade === 1 ? "#f5f5f5" : "#ffffff"}; */

  div {
    color: ${({ isSystem }) => (isSystem ? "#aaaaaa !important" : "#2f2f38")};
  }
`;

export const ChatRowItem = styled.div<{
  clickable?: boolean;
  isNeedLineThrough?: boolean;
}>`
  width: 100%;

  cursor: ${({ clickable }) => (clickable ? "pointer" : "auto")};
  text-decoration: ${({ clickable, isNeedLineThrough }) =>
    isNeedLineThrough ? "line-through" : clickable ? "underline" : "none"};
  padding: 21px 10px;
  font-size: 15px;
  font-weight: 500;
  line-height: 22.5px;
  text-align: left;
  color: #2f2f38;
  height: 100%;
  vertical-align: middle;
  word-break: keep-all;

  &:nth-child(1) {
    flex: 1;
  }

  &:nth-child(2) {
    flex: 1;
  }

  &:nth-child(3) {
    flex: 4;
  }

  &:nth-child(4) {
    flex: 2;
  }

  &:nth-child(5) {
    flex: 1;
  }
`;

export const LatestMessageBadge = styled.span<{
  isSystem: boolean;
}>`
  margin-left: 8px;
  border-radius: 3px;
  background-color: ${({ isSystem, theme }) =>
    isSystem ? theme.color.gray400 : theme.color.white};
  padding: 4px 6px;

  font-size: 12px;
  font-weight: bold;
  line-height: 18px;
  text-align: center;
  color: ${({ isSystem, theme }) =>
    isSystem ? theme.color.white : theme.color.gray400};
`;

const Icon = styled.img`
  width: 24px;
  height: 24px;
`;
